'use strict';

/* eslint-disable @typescript-eslint/no-explicit-any */ exports.Expect = void 0;
(function(Expect) {
    Expect["UNION"] = "UNION";
    Expect["NOT_UNION"] = "NOT_UNION";
    Expect["MATCH"] = "MATCH";
    Expect["NO_MATCH"] = "NO_MATCH";
    Expect["TRUE"] = "TRUE";
    Expect["FALSE"] = "FALSE";
    Expect["NEVER"] = "NEVER";
})(exports.Expect || (exports.Expect = {}));
